import { http } from '../../../api'

const about = {
  namespaced: true,
  state: {
    settingsList: []
  },
  actions: {
    getSettingsList: ({ commit }) => {
      return http.get('/about').then(res => {
        commit('setSettingsList', res.data.data)
      })
    },
    getSetting: ({ commit }, id) => {
      return http.get('/about/' + id).then(res => {
        commit('setSettingsList', res.data.data)
        return res.data.data
      })
    },
    updateSettings: ({ commit }, params) => {
      return http.post('/about-update', params.data).then(res => {
      })
    },
    updateSettingsImage: ({ commit }, params) => {
      return http.post('/about-update-img/' + params.id, params.data).then(res => {
      })
    },
    createSettings: ({ commit }, params) => {
      return http.post('/about', params.data).then(res => {
      })
    },
    deleteItem: ({ commit }, id) => {
      return http.delete('/about/' + id).then(res => {
        commit('deleteAbout', id)
      })
    }
  },
  mutations: {
    setSettingsList (state, data) {
      state.settingsList = data
    },
    deleteAbout (state, id) {
      state.settingsList = state.settingsList.filter(item => item.id !== id)
    }
  },
  getters: {
    settingsList: state => state.settingsList
  }
}

export default about
